var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.$vuetify.theme.dark,"light":!_vm.$vuetify.theme.dark}},[(_vm.authenticated)?_c('div',{staticClass:"authenticated"},[_c('PrivateLayout')],1):_c('div',{staticClass:"unauthenticated"},[_c('PublicLayout')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }